export default {
  priv: 'pr_manage',
  overviewTitle: 'Groepen',
  detailTitle: 'Groep',
  deleteTitle: 'deze groep',
  url: '/manage/groups',
  apiUrl: '/userroles/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'mnggroups',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'text'
  },
  newRecord: {
    pr_manage_id: 1,
    pr_reference_id: 1,
    pr_device_id: 1,
    pr_site_id: 1,
    pr_intervention_id: 1,
    pr_site_service_order_id: 1,
    pr_site_notification_id: 1,
    pr_site_files_id: 1,
    pr_device_files_id: 1,
    pr_tc_id: 1,
    pr_tc_service_order_id: 1,
    pr_tc_notification_id: 1,
    pr_tc_files_id: 1
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/manage/groups/{id}',
      width: '21%'
    },
    {
      text: 'Beheer',
      value: 'pr_manage',
      width: '3%',
      sortable: false
    },
    {
      text: 'Ref',
      value: 'pr_reference',
      width: '3%',
      sortable: false
    },
    {
      text: 'Interv.',
      value: 'pr_intervention',
      width: '3%',
      sortable: false
    },
    {
      text: 'Cam',
      value: 'pr_device',
      width: '3%',
      sortable: false
    },
    {
      text: 'Cam Files',
      value: 'pr_device_files',
      width: '3%',
      sortable: false
    },
    {
      text: 'Sites',
      value: 'pr_site',
      width: '3%',
      sortable: false
    },
    {
      text: 'Site Files',
      value: 'pr_site_files',
      width: '3%',
      sortable: false
    },
    {
      text: 'Site DB',
      value: 'pr_site_service_order',
      width: '3%',
      sortable: false
    },
    {
      text: 'Site Meld.',
      value: 'pr_site_notification',
      width: '3%',
      sortable: false
    },
    {
      text: 'TC',
      value: 'pr_tc',
      width: '3%',
      sortable: false
    },
    {
      text: 'TC Files',
      value: 'pr_tc_files',
      width: '3%',
      sortable: false
    },
    {
      text: 'TC DB',
      value: 'pr_tc_service_order',
      width: '3%',
      sortable: false
    },
    {
      text: 'TC Meld.',
      value: 'pr_tc_notification',
      width: '3%',
      sortable: false
    }
  ]
};
